import React, { useEffect } from 'react';
import '../styles/casino.css';

const ReddyAnnaHorseRacePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="casino-betting-page">
      <div className="casino-betting-intro">
        <div className="casino-betting-intro-content">
          <h1><span>Mahadev Casino:</span> Your Gateway to Elite Gaming</h1>
          <p>
            Step into Mahadev Casino — a world where luxury meets thrill. From immersive live dealer tables to fast-paced virtual games, we bring you the ultimate online casino experience, all from the comfort of your screen. Whether you're chasing big wins or enjoying casual play, Mahadev Casino delivers world-class entertainment at every turn.
          </p>
          <div className="casino-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="casino-betting-intro-image">
          <img src="/casino.webp" alt="Casino Gaming" />
        </div>
      </div>

      <section className="casino-betting-features">
        <h2>Why Play at <span>Mahadev Casino?</span></h2>
        <p>
          We’ve crafted a premium environment that’s designed for both high-rollers and first-time players. Every detail—from our game variety to seamless gameplay—reflects our commitment to elite online gaming.
        </p>
        <ol>
          <li>
            <strong>Massive Game Selection:</strong> From timeless classics like Blackjack, Roulette, and Poker to modern favorites like Dragon Tiger and Teen Patti, enjoy nonstop action across multiple game lobbies.
          </li>
          <li>
            <strong>Live Dealer Excellence:</strong> Feel the pulse of real-time gaming with live dealers. Engage, interact, and play with professionals in a setting that feels just like Vegas.
          </li>
          <li>
            <strong>User-Friendly Interface:</strong> Whether on desktop or mobile, our platform is sleek and intuitive. Find games easily, join lobbies instantly, and enjoy smooth gameplay.
          </li>
          <li>
            <strong>Safe & Secure Transactions:</strong> Your privacy is our top priority. All transactions are encrypted and fully secure, so you can play with complete peace of mind.
          </li>
          <li>
            <strong>Responsible Gaming First:</strong> We promote safe and balanced play. Set limits, play smart, and stay in control — we’re here to ensure a healthy, enjoyable experience.
          </li>
        </ol>
      </section>

      <section className="casino-betting-getting-started">
        <h2>We're With You Every Step of the Way</h2>
        <p>
          Our dedicated support team is available around the clock to guide you — whether you need help getting started, navigating games, or managing your account. You're never alone at Mahadev Casino.
        </p>
        <p>
          Ready to elevate your entertainment? Join Mahadev Casino today and dive into a premium, secure, and unforgettable gaming world.
        </p>
      </section>

      <section className="casino-betting-join">
        <h2>Join <span>Mahadev Casino</span> Today</h2>
        <p>
          Discover elite gaming, tailor-made for players who expect more. With trusted support, high-quality games, and effortless play — Mahadev Casino is where your winning streak begins. Let the good times roll!
        </p>
        <div className="casino-betting-cta-buttons">
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default ReddyAnnaHorseRacePage;
